import { normalizeRestrictedRichTextLinkHref } from "../schema/emailDocumentUrlValidation";

export function resolveEmailBuilderInlineTextAppliedHref(href: string): string {
  const trimmedHref = href.trim();
  return trimmedHref === "" ? "" : normalizeRestrictedRichTextLinkHref(href).replace(/"/g, "");
}
